import React from 'react';
import { Hero } from '../components/Hero';
import { Testimonials } from '../components/Testimonials';
import { PainPoints } from '../components/PainPoints';
import { TargetAudience } from '../components/TargetAudience';
import { TheSystem } from '../components/TheSystem';
import { Tomos } from '../components/Tomos';
import { Bonos } from '../components/Bonos';
import { Comparison } from '../components/Comparison';
import { CountdownSection } from '../components/CountdownSection';
import { Pricing } from '../components/Pricing';
import { WhatYouLose } from '../components/WhatYouLose';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { RecentPurchasePopup } from '../components/RecentPurchasePopup';
export function LandingPage() {
  return <main className="w-full overflow-hidden relative" data-id="element-300">
      <RecentPurchasePopup data-id="element-301" />
      <Hero data-id="element-302" />
      <Testimonials data-id="element-303" />
      <PainPoints data-id="element-304" />
      <TargetAudience data-id="element-305" />
      <TheSystem data-id="element-306" />
      <Tomos data-id="element-307" />
      <Bonos data-id="element-308" />
      <Comparison data-id="element-309" />
      <CountdownSection data-id="element-310" />
      <Pricing data-id="element-311" />
      <WhatYouLose data-id="element-312" />
      <Guarantee data-id="element-313" />
      <FAQ data-id="element-314" />
      <CountdownSection isFinal data-id="element-315" />
      <Pricing isFinal data-id="element-316" />
      <Footer data-id="element-317" />
    </main>;
}